module.exports = __webpack_public_path__ + "static/img/person-1.f338325.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/person-1.png
// module id = c5/7
// module chunks = 1